import React from 'react';
import { ParsedCitation } from '@/lib/citations/parseCitations';

export interface CitationListProps {
  citations: ParsedCitation[];
  t: (key: string, defaultValue?: string) => string;
  messageId?: string;
}

export const CitationList: React.FC<CitationListProps> = ({
  citations,
  t,
  messageId
}) => {
  if (citations.length === 0) return null;

  return (
    <div className="mt-6 pt-4 border-t border-neutral-200 dark:border-neutral-700 text-xs">
      <div className="font-semibold text-neutral-500 dark:text-neutral-400 mb-3">
        {t('sources', 'Sumber:')}
      </div>
      <div className="flex flex-col gap-3">
        {citations.map((citation) => (
          <div
            key={citation.index}
            id={messageId ? `citation-${messageId}-${citation.index}` : `citation-${citation.index}`}
            className="flex items-start gap-2"
          >
            <span className="inline-block bg-neutral-100 text-neutral-500 dark:bg-neutral-800 dark:text-neutral-400 px-1.5 py-0.5 rounded-md text-[0.7rem] font-bold flex-shrink-0 mt-0.5">
              {citation.index}
            </span>
            <div className="flex-1 text-neutral-500 dark:text-neutral-400 leading-relaxed">
              {citation.text}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
